var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.656 7.321H4.043l6.352-5.428a.142.142 0 0 0-.094-.25H8.696a.294.294 0 0 0-.19.07L1.65 7.567a.571.571 0 0 0-.2.43.563.563 0 0 0 .2.432l6.895 5.891c.027.023.06.036.094.036h1.66c.134 0 .196-.164.094-.25l-6.35-5.429h10.613c.08 0 .145-.064.145-.143V7.464a.144.144 0 0 0-.145-.143z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftFull);
export default __webpack_public_path__ + "static/media/arrow-left-full.3c77825d44ff3e85badf4009c7237bb8.svg";
export { ForwardRef as ReactComponent };